import noReport from "../assets/theme3/insets/no-content.png";
import noNetwork from "../assets/theme3/insets/no-network.png";
import remind from "../assets/theme3/insets/remind.png";
import welcome from "../assets/theme3/insets/welcome.png";
var theme3ImageData = {
  name: 'images',
  global: true,
  data: [
  // 配套主题的插图
  {
    noReport: noReport,
    // 无内容2
    noNetwork: noNetwork,
    // 无网络
    remind: remind,
    // 提示消息（尊敬的用户您好......）
    welcome: welcome // 欢迎插画
  }]
};

export { theme3ImageData };